// extracted by mini-css-extract-plugin
export default {"Standard":"WorkPermitState_Standard__EqTY9","Compact":"WorkPermitState_Compact__CLfMQ"};